import React from 'react';

const AnimatedTotalCountIcon = (props) => {
	const count_number = props?.count_number ?? false;
	if(count_number === false) return null;

	return (
		<span class="gui_animated_total_count">
			<span class="count_digit">
				<span>
					<span>{count_number}</span>

					<span>{count_number + 1}</span>
				</span>
			</span>
		</span>
	)
};

export default AnimatedTotalCountIcon;